import { Show } from 'solid-js';
import styles from './BotStatusBadge.module.css';

export type BotState =
    | 'Offline'
    | 'Pending'
    | 'Connecting'
    | 'Playing'
    | 'Reconnecting'
    | 'Disconnecting'
    | 'Disconnected'
    | 'Error'
    | string; // tolerate forward-compat additions

// Everything except these two means the backend still holds a live instance for the bot.
export const hasRunningInstance = (state: BotState | null | undefined): boolean =>
    state !== undefined && state !== null && state !== 'Offline' && state !== 'Pending';

interface BotStatusBadgeProps {
    state: BotState | null | undefined;
    compact?: boolean;
}

export default function BotStatusBadge(props: BotStatusBadgeProps) {
    const state = () => props.state ?? 'Offline';
    const cls = () => {
        switch (state()) {
            case 'Playing':       return styles.playing;
            case 'Connecting':    return styles.connecting;
            case 'Reconnecting':  return styles.reconnecting;
            case 'Disconnecting': return styles.disconnecting;
            case 'Pending':       return styles.pending;
            case 'Disconnected':  return styles.disconnected;
            case 'Error':         return styles.error;
            case 'Offline':
            default:              return styles.offline;
        }
    };
    const label = () => {
        switch (state()) {
            case 'Playing':       return 'Online';
            case 'Connecting':    return 'Connecting';
            case 'Reconnecting':  return 'Reconnecting';
            case 'Disconnecting': return 'Stopping';
            case 'Pending':       return 'Pending';
            case 'Disconnected':  return 'Disconnected';
            case 'Error':         return 'Error';
            case 'Offline':       return 'Offline';
            default:              return String(state());
        }
    };

    return (
        <span
            class={`${styles.badge} ${cls()} ${props.compact ? styles.compact : ''}`}
            title={label()}
        >
            <span class={styles.dot} />
            <Show when={!props.compact}>
                <span class={styles.label}>{label()}</span>
            </Show>
        </span>
    );
}
